/**
 * PrintButton
 */

import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { IntlPropType, trackContentInteraction } from "root/libs/core-libs/src";
import { DhlButton } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";

const COPY_ID_PREFIX = "PrintButton";

const PrintButton = (props) => {
  const { dataTestid, dataTracking, intl, utfDataObject } = props;

  function onClick() {
    const { trackEvent, trackingValue } = props;

    if (
      document &&
      document.queryCommandSupported &&
      document.queryCommandSupported("print")
    ) {
      document.execCommand("print", false, null);
    } else if (window && window.print) {
      window.print();
    }

    trackEvent(trackingValue);
    trackContentInteraction(utfDataObject);
  }

  return (
    <DhlButton
      isFullWidth
      name="button"
      variant={Variants.outline}
      type="button"
      dataTestid={dataTestid}
      clickEvent={onClick}
      dataTracking={dataTracking}
    >
      {intl.formatMessage({ id: `${COPY_ID_PREFIX}.label` })}
    </DhlButton>
  );
};

PrintButton.propTypes = {
  intl: IntlPropType.isRequired,
  dataTestid: PropTypes.string,
  dataTracking: PropTypes.string,
  trackEvent: PropTypes.func,
  trackingValue: PropTypes.object,
  utfDataObject: PropTypes.object,
};

PrintButton.defaultProps = {
  dataTestid: undefined,
  dataTracking: "",
  trackEvent: () => {},
  trackingValue: {},
  utfDataObject: {},
};

export default injectIntl(PrintButton);
